<template>
  <div class="login-container">
    <div class="login-box">
      <h1 class="login-title">🥳 欢迎登录ZError</h1>
      <div class="main-container">
        <div class="right-container">
          <p>微信登录</p>
          <img src="公众号二维码.jpg">
          <div class="verification-text" v-if="verificationCode">
            <span>验证码已生成：</span>
            <div class="verification-code-container">
              <span class="tooltip">{{ copyStatus }}</span>
              <span class="verification-code" @click="copyCode" @mouseleave="handleMouseLeave">{{ verificationCode
                }}</span>
            </div>
          </div>

          <div class="instructions">
            <span>☝️关注上方公众号</span>
            <span class="blue-text">未耕之地</span>
            <span>发送验证码完成登录</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import apiConfig from "../config/api.js";

export default {
  data() {
    return {
      copyStatus: "复制",
      verificationCode: "",
      intervalId: null,
    };
  },
  methods: {
    startPolling() {
      console.log('开始轮询');
      // 定义轮询的定时器ID
      this.intervalId = setInterval(() => {
        // 使用新的轮询地址
        const url = `${apiConfig.appURL}/polling`;
        console.log('轮询请求URL:', url);

        // 发送POST请求，并在请求体中包含验证码
        axios.post(url, { verification_code: this.verificationCode })
          .then(response => {
            console.log('轮询响应:', response.data);
            // 判断返回数据中的 logged_in
            if (response.data.logged_in === true) {
              // 停止定时器
              clearInterval(this.intervalId);
              this.intervalId = null;
              // 进行下一步操作
              this.handleVerified(response);
            }
          })
          .catch(error => {
            // 处理请求错误
            console.error('轮询请求失败:', error);
          });
      }, 5000); // 每隔5秒发送一次请求
    },

    // 当status为verified时的下一步操作
    handleVerified(response) {
      console.log('Verification successful, proceed with next step.', response.data);
      
      // 检查返回的数据结构
      if (response.data && response.data.user) {
        const userData = response.data.user;
        
        // 存储用户信息
        localStorage.setItem("token", userData.token);
        localStorage.setItem("nickname", userData.nickname);
        localStorage.setItem("createdTime", userData.createdTime);
        
        // 清除验证码相关信息
        localStorage.removeItem('verificationCode');
        localStorage.removeItem('verificationTimestamp');
        
        console.log('用户信息已存储，准备跳转到仪表盘');
        
        // 停止轮询
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
        
        // 跳转到用户主页
        this.$router.push("/dashboard");
      } else {
        console.error('返回的数据格式不正确:', response.data);
      }
    },
    async triggerCode() {
      const storedCode = localStorage.getItem('verificationCode');
      const storedTimestamp = localStorage.getItem('verificationTimestamp');
  
      // 检查验证码是否存在且有效（5分钟有效期）
      if (storedCode && storedTimestamp && (Date.now() - storedTimestamp < 5 * 60 * 1000)) {
        this.verificationCode = storedCode;
        this.startPolling();  // 添加这行，使用存储的验证码也开始轮询
        return;
      }
  
      // 如果验证码不存在或已过期，重新获取
      try {
        // 修改为新的请求地址
        const response = await axios.post(`${apiConfig.appURL}/trigger_login`);
        if (response.data.verification_code) {
          this.verificationCode = response.data.verification_code;
          // 将验证码和时间存储到localStorage
          localStorage.setItem('verificationCode', this.verificationCode);
          localStorage.setItem('verificationTimestamp', Date.now().toString());
  
          this.startPolling();  // 确保这行代码存在
        }
      } catch (error) {
        console.error("验证码获取失败", error);
      }
    },
    updatePage() {
      var screenWidth = window.screen.width;

      if (screenWidth > 768) {
        this.showAccount = true;
        this.showWechat = true;
      } else {
        this.copyStatus = "复制成功"
        if (this.selectedOption === 'Option 1') {
          this.showAccount = true;
          this.showWechat = false;
        } else {
          this.showAccount = false;
          this.showWechat = true;
        }
      }
    },

    copyToClipboard(text) {
      // 检查 Clipboard API 是否支持
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () {
          console.log("内容已复制到剪贴板！");
        }).catch(function (error) {
          console.error("复制失败: ", error);
        });
      } else {
        // 使用 document.execCommand 作为回退
        var textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          var successful = document.execCommand('copy');
          if (successful) {
            console.log("内容已复制到剪贴板！");
          } else {
            console.error("复制失败");
          }
        } catch (error) {
          console.error("复制失败: ", error);
        }
        document.body.removeChild(textArea);
      }
    },
    copyCode() {
      this.copyToClipboard(this.verificationCode);
      this.copyStatus = "复制成功";
    },
    handleMouseLeave() {
      this.copyStatus = "复制";
    }
  },
  mounted() {
    const token = localStorage.getItem("token");
    if (token) {
      this.$router.push("/dashboard"); // 修改这里，从 "/id" 改为 "/dashboard"
    }
    this.triggerCode();
  },
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
  background: #ffffff;
  min-height: 377px;
  padding-top: 94px;
}

.login-box {
  background: rgb(255, 255, 255);
  border-radius: 1.5rem;
  box-shadow: 8px 8px 20px 0 rgba(0, 0, 0, 0.02);
  padding: 20px 30px;
  width: 100%;
  max-width: 577px;
  border: 1.2px solid rgb(239, 239, 239);
  margin: 0px;
}

.main-container {
  display: flex;
}

.left-container {
  border-right: #333;
}

.divider {
  height: 280px;
  width: 0.8px;
  background-color: #dfdfdf;
  margin-left: 20px;
  margin-right: 20px;
}

.login-title {
  color: #fbc760;
  text-align: center;
  font-size: 2em;
  margin-bottom: 20px;
}

.input-group {
  margin-bottom: 15px;
}

.input-field {
  width: 90%;
  height: 60px;
  font-size: 1em;
  /* 字体大小 */
  font-family: 'Arial', sans-serif;
  /* 设置字体类型 */
  font-weight: 400;
  /* 设置字体粗细 */
  color: #333;
  /* 设置输入文字颜色 */
  line-height: 60px;
  /* 设置文字垂直居中 */
  padding-left: 15px;
  /* 设置文字左边距 */
  border: 1.2px solid rgb(239, 239, 239);
  border-radius: 1.5rem;
  outline: none;
  transition: border-color 0.3s ease;
}

.input-field::placeholder {
  color: #aaa;
  /* 设置输入框占位符文字颜色 */
  font-style: italic;
  /* 设置占位符字体样式 */
}

.input-field:focus {
  border-color: rgb(254, 208, 1);
}

/* 新增：使登录按钮居中 */
.button-group {
  display: flex;
  justify-content: center;
}

.login-btn {
  padding-top: .5rem;
  padding-bottom: .5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  background-color: rgb(254, 208, 1);
  color: white;
  border: 1.2px solid rgb(239, 239, 239);
  border-radius: 9999px;
  font-size: 1em;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.login-btn:hover {
  background-color: rgb(245, 219, 18);
  border-color: rgb(239, 239, 239);
}

.register-link {
  text-align: center;
  margin-top: 20px;
}

.register-link a {
  color: #03a9f5;
  text-decoration: none;
}

.register-link a:hover {
  text-decoration: underline;
  text-decoration: none;
}

.right-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 30px;
}



img {
  width: 150px;
}

.verification-text {
  font-size: 16px;
  margin-bottom: 10px;
}

.verification-code {
  border-radius: 4px;
  padding: 3px 6px;
  background-color: rgba(142, 150, 170, .14);
  font-size: 0.875rem;
  color: #333;
}

.verification-code:hover {
  color: #007BFF;
  cursor: pointer;
}

.instructions {
  font-size: 14px;
}

.blue-text {
  color: #007BFF;
  font-weight: bold;
}

.copy-success {
  color: green;
  margin-top: 10px;
  font-size: 14px;
}

.verification-code-container {
  position: relative;
  font-weight: 600;
  color: #e8e8e8;
  border-radius: 8px;
  cursor: pointer;
  display: inline-block;
}

.tooltip {
  width: max-content;
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  padding: 0.3em 0.6em;
  opacity: 0;
  pointer-events: none;
  background: #333;
  color: #fff;
  border-radius: 8px;
  font-size: 12px;
  transition: opacity 0.4s cubic-bezier(0.23, 1, 0.32, 1), transform 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  box-shadow: rgba(0, 0, 0, 0.25) 0 8px 15px;
}

.tooltip::before {
  position: absolute;
  content: "";
  height: 0.6em;
  width: 0.6em;
  bottom: -0.2em;
  left: 50%;
  transform: translate(-50%) rotate(45deg);
  background: #333;
}

.verification-code-container:hover .tooltip {
  opacity: 1;
  transform: translateX(-50%) translateY(-10px);
  animation: shake 0.5s ease-in-out both;
}

@keyframes shake {
  0% {
    rotate: 0;
  }

  25% {
    rotate: 7deg;
  }

  50% {
    rotate: -7deg;
  }

  75% {
    rotate: 1deg;
  }

  100% {
    rotate: 0;
  }
}

@media (max-width: 768px) {

.login-box {
    margin-left: 10px;
    margin-right: 10px;

  } 
.login-container{
  padding-top: 50px;
  height: 70vh;
}

}


</style>